<template>
    <div>
        <label class="d-block">Mögliche erzeugbare Dateianhänge</label>
        <b-table ref="documentTable" :fields="attachmentFields"
            :items="preparedAttachments">
            <template v-slot:cell(selected)="rowData">
                <b-form-checkbox :checked="rowData.item.checked"
                    :value="rowData.item.name"
                    @change="(checked) => handleCheckboxChange(rowData, checked)"/>
            </template>
        </b-table>
    </div>
</template>

<script>

    export default {
        name: 'DocumentAttachments',
        props: {
            attachments: {
                type: Array,
                required: true,
            },
            form: {
                type: Object,
                required: true,
            },
        },
        data() {
            return {
                attachmentFields: [
                    {
                        key: 'selected',
                        label: 'Auswählen',
                        thStyle: {width: '95px'},
                    },
                    {
                        key: 'label',
                        label: 'Dokument',
                    },
                ],
                preparedAttachments: [],
            }
        },
        mounted() {
            if (Array.isArray(this.attachments)) {
                this.attachments.forEach(attachment => {
                    if (attachment.label !== null) {
                        attachment.checked = false;
                        this.preparedAttachments.push(attachment);
                    }
                });
            }
        },
        methods: {
            handleCheckboxChange(rowData, checked) {
                if (checked) {
                    rowData.item.checked = rowData.item.name;
                } else {
                    rowData.item.checked = false;
                }
                this.form.setData(this.preparedAttachments);
            },
        },
    }
</script>
